import { Box, List, ListItem, ListItemText, Typography } from "@mui/material"
import { mahiBffUrl } from "../../../data/hikoFetch"
import { DlspGenericFileUploadPanel } from "./DlspGenericFileUploadPanel"

const bffBaseUrl = mahiBffUrl()

export function DlspDesktopFileUploadPanel({icp, fspStatusNoEdit}) {

    const bffUploadPath = `/bff/decommissioned-lines-service/api/decommissioned-lines/desktop-inspection-image/upload?icp=${icp}`
    const bffGetAllPath = `/bff/decommissioned-lines-service/api/decommissioned-lines/desktop-inspection-image/get-all`
    const bffDeletePath = `/bff/decommissioned-lines-service/api/decommissioned-lines/desktop-inspection-image/delete`

    return (

        <Box>
            <Typography variant="body1">
                Please upload the following:<br />
            </Typography>
            <List sx={{ listStyleType: 'disc', pl:4, mb:3 }}>
                <ListItem sx={{p: 0, display: 'list-item' }}>
                    <ListItemText primary="A GIS screenshot of the decommissioned ICP" />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item' }}>
                    <ListItemText primary="A Northpower Asset Inspection screenshot showing the service line connection to the network, e.g. the nearest pole" />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item' }}>
                    <ListItemText primary="Any other screenshots you think are relevant, e.g. more Asset Inspection, GIS or Google Maps screenshots, excerpts from Decommissioning Records" />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item' }}>
                    <ListItemText primary="If the service line is visible, a wide area photo (e.g. from Asset Inspection or Google Maps) showing the area around the line and its connection to the network." />
                </ListItem>
            </List>
            <DlspGenericFileUploadPanel icp={icp} bffBaseUrl={bffBaseUrl} bffUploadPath={bffUploadPath} bffGetAllPath={bffGetAllPath} bffDeletePath={bffDeletePath} fspStatusNoEdit={fspStatusNoEdit} />
        </Box>
    )
}